import React from "react";
import styles from "./WhyPuducherry.module.css";
import prose from "../../styles/prose.module.css";
import PuducherryImage from "../../assets/puducherry.png";
import SectionHeading from "../../ReusableComponents/SectionHeading/SectionHeading";
import Reveal from "../../ReusableComponents/Reveal/Reveal";

const reasons = [
  {
    title: "Model City",
    body: "Chosen as a model city to demonstrate people-first development.",
  },
  {
    title: "National Blueprint",
    body: "Replicable model for India — a blueprint for national transformation.",
  },
  {
    title: "Strategic Location",
    body: "Coastal region with educated population and entrepreneurial spirit.",
  },
];

export default function WhyPuducherry() {
  return (
    <section id="why-puducherry" className={styles.section}>
      <div className={styles.inner}>
        <SectionHeading
          eyebrow="The choice"
          title="Why Puducherry?"
          lead="Not by chance, but by choice — a region small enough to change and strong enough to prove the point."
        />

        <div className={styles.split}>
          <Reveal className={styles.imageSection} x={-40} y={0} duration={1}>
            <figure className={styles.frame}>
              <img
                src={PuducherryImage}
                alt="Puducherry"
                className={styles.image}
              />
            </figure>
          </Reveal>

          <Reveal
            className={styles.textSection}
            selector="[data-movement]"
            stagger={0.08}
            y={28}
          >
            <div className={`${prose.movement} ${prose.leadMovement}`} data-movement>
              <p className={prose.paragraph}>
                Jose Charles Martin chose Puducherry not by chance, but by choice.
                For him, Puducherry represents the heart of potential- a coastal
                region blessed with an educated population, cultural richness,
                entrepreneurial spirit, and untapped opportunities. He believes that
                Puducherry, with its manageable size and strong community bonds, is
                the ideal place to model sustainable, people-first development.
              </p>
            </div>

            <div className={prose.movement} data-movement>
              <span className={prose.kicker}>
                <span className={prose.kickerRule} aria-hidden="true" />
                The larger vision
              </span>
              <p className={prose.paragraph}>
                By transforming Puducherry into a global benchmark of growth,
                cleanliness, and innovation, he aims to create a living example of
                what visionary governance and collective effort can achieve. Jose’s
                focus is not limited to one region- Puducherry is the beginning of a
                larger national vision. Once the transformation succeeds here, his
                goal is to replicate this “Puducherry Model” across India, inspiring
                progress in every state and making India the best place to live in
                the world.
              </p>
            </div>
          </Reveal>
        </div>

        <Reveal className={styles.quoteWrap} y={26}>
          {/* Lifted from the passage above it. */}
          <blockquote className={prose.pullQuote}>
            <span className={prose.quoteMark} aria-hidden="true">
              &ldquo;
            </span>
            <p>Puducherry is the beginning of a larger national vision.</p>
          </blockquote>
        </Reveal>

        <Reveal
          className={styles.cards}
          selector="[data-card]"
          stagger={0.1}
          y={34}
        >
          {reasons.map((reason, index) => (
            <article className={styles.card} key={reason.title} data-card>
              <span className={styles.cardIndex} aria-hidden="true">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className={styles.cardTitle}>{reason.title}</h3>
              <p className={styles.cardBody}>{reason.body}</p>
            </article>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
